/**
 * Saisie d'un code formacode pour une recherche EXACTE (distincte de la recherche par
 * libellé) : même contrainte que la colonne, 10 caractères au plus, sans espace.
 */
export function lireCodeFormacode(saisie: string): { code: string | undefined; erreur: string | null } {
  const code = saisie.trim();
  if (!code) return { code: undefined, erreur: null };
  if (code.length > 10 || /\s/.test(code)) {
    return { code: undefined, erreur: 'Code formacode : 10 caractères au plus, sans espace.' };
  }
  return { code, erreur: null };
}
